module.exports = __webpack_public_path__ + "img/Redeemed.ec72db93.png";